module.exports = __webpack_public_path__ + "img/transfer7.05f54f9f.jpg";